import BackdropLoading from 'components/common/BackdropLoading';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { OLD_ROUTE } from 'utils/constants';

import { useUserAuth } from 'hooks/useUserAuth';

const PageCheckedHome = () => {
  const { status } = useUserAuth();
  const { t } = useTranslation();

  if (status === 'loading') {
    return <BackdropLoading open loadingText={t('common:loading')} />;
  }

  if (status === 'anonymous') {
    return <Redirect to="/sign-in" />;
  }

  if (status === 'degraded') {
    // Session kept but unrefreshable: the private route shows the degraded banner; keep OLD_ROUTE for later.
    return <Redirect to="/orders" />;
  }

  const location = localStorage.getItem(OLD_ROUTE);

  if (location) {
    // Remove only the saved route; session keys (refresh token, client id) must survive.
    localStorage.removeItem(OLD_ROUTE);
    return <Redirect to={location} />;
  }

  return <Redirect to="/orders" />;
};

export default PageCheckedHome;
